import React from 'react';
import { Trans } from 'react-i18next';

type TextMarker = {
  text: string;
  type?: 'strong';
};

const solarRegexStart = '$hl%start§';

export function removeHighlightingTags(text: string): string {
  return text.replace(/\$hl%start§/g, '').replace(/\$hl%end§/g, '');
}

/**
 *  Highlights Text with <mark> or <strong> Elements
 *  Currently only for SOLR-Output
 */
export function TextMarker({ text, type }: TextMarker) {
  if (!text?.includes(solarRegexStart)) {
    return text;
  }

  /**
   * Using trans component here as old implementation got a problem after react update with ambigious keys and therefore
   *  adding the same text multiple times on re-render (compareSIBZIEL-15195).
   *  Only drawback we swapped console messages for elements with same key for missing language key logs.
   */
  const tmp = text.replace(/\$hl%start§/g, '<0>').replace(/\$hl%end§/g, '</0>');

  if (type === 'strong') {
    return (
      <Trans components={[<strong key={tmp} className="text-marker text-marker--strong" />]}>
        {tmp}
      </Trans>
    );
  }

  return (
    <Trans components={[<mark key={tmp} className="text-marker" />]}>
      {tmp}
    </Trans>
  );
}
